module.exports = __webpack_public_path__ + "img/signatureEle.e8bc86ff.svg";